import { CandidateList } from 'pages/common/CandidateList';
import React from 'react';

const Candidates = () => {
  return <CandidateList />;
};

export default Candidates;
